//--------------------------------
//共通処理、共通変数定義
//--------------------------------
export default {
	created() {
		console.log('start! from mixins.');
	},
	data() {
		//本番環境
		const geoserverUrl = "http://gis.quake-learning.pref.aichi.jp/geoserver/"; // geoserverのUrl
		const simulatorUrl = "http://sim1.quake-learning.pref.aichi.jp/";
		const portalUrl = "https://www.quake-learning.pref.aichi.jp/";
		const chiikiUrl = "http://area.quake-learning.pref.aichi.jp/";
		//開発環境
		//const geoserverUrl = "http://ab-gis.fal.co.jp/geoserver/"; // geoserverのUrl
		//const simulatorUrl = "http://ab-sim.fal.co.jp/";
		//const portalUrl = "https://ab-www.fal.co.jp/";
		//const chiikiUrl = "http://ab-area.fal.co.jp/";
		return {
			geoserverWmsUrl: geoserverUrl + "wms/",
			geoserverWfsUrl: geoserverUrl + "wfs/",
			simSelectUrl: simulatorUrl + "simulator/",
			simCadUrl: simulatorUrl + "ground/",
			chiikiMapUrl:chiikiUrl+"map/wms?SERVICE=WMS&cid=2&mid=12&",
			portalUrl: portalUrl,
			centerMark: '/image/gps.png',                       //中心位置画像
			centerLonLat: [137.2000, 34.9500]                   //初期表示座標
		}
	},
	methods: {
		logging() {
			console.log('logging from mixins.')
		}
	},
	computed: {
	}
}
